// extracted by mini-css-extract-plugin
export default {"main_container":"Loader_main_container__vPVKo","lds_spinner":"Loader_lds_spinner__wgf2K"};